import { render, staticRenderFns } from "./TransportPage.vue?vue&type=template&id=3b92c05a"
import script from "./TransportPage.vue?vue&type=script&lang=js"
export * from "./TransportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports